module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAIVBMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO4RDnu2AAAACnRSTlMAn4AQjyAw76+/XJpknQAAAJ9JREFUeNrt1EsKgDAQwNB+bKu9/4EVEbKWFASZHOAtk17XylVPujzvcvXOI2kHSTpI1kGyDpJ1kKyDZB0k6yBZB8k6SNZBsg6SdZCsgyQdas6hIh0g6QBJB8g51Bc5OZxwwgknnHB+5mzOoVVOlQ4N51CRDm0rHCLpkHRIOiQdkg5Jh6RD0iHpkHRIOiQdkg7hyJY4/GlPvjLmPGr6qBME3FNqh0q8UwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f516.png
// module id = 1097
// module chunks = 0